import {WalletTransferContext} from '#/components/wallet-transfer/wallet-transfer-context';
import {WalletTransferTab} from '#/components/wallet-transfer/wallet-transfer-tab';
import {useContext, useEffect} from 'react';

export const useWalletTransferCompletedStepOnSuccess = (isSuccess: boolean, currentTab: WalletTransferTab) => {
  const {tab, completedTabs, setCompletedTabs} = useContext(WalletTransferContext);

  useEffect(() => {
    if (isSuccess && tab === currentTab && !completedTabs.includes(currentTab)) {
      setCompletedTabs(prev => {
        if (!prev.includes(tab)) {
          return [...prev, tab];
        }
        return prev;
      });
    }
  }, [completedTabs, currentTab, isSuccess, setCompletedTabs, tab]);
};
